import type { User } from '../types';

const getStringValue = (value?: string | null) => value?.trim() || '';

const getFullName = ({ firstName, lastName, email }: Pick<User, 'firstName' | 'lastName'> & { email?: string | null }) =>
  [firstName, lastName].map(getStringValue).filter(Boolean).join(' ') || getStringValue(email);

export default getFullName;
